module.exports = __webpack_public_path__ + "assets/shops.d10e83f5.svg";